import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import {FormsModule} from "@angular/forms";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatCardModule} from "@angular/material/card";
import {MatSelectModule} from "@angular/material/select";
import {MatListModule} from "@angular/material/list";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {AccountRequestModule} from "@app/login/account-request/account-request.module";
import {ForgotPasswordModule} from "@app/login/forgot-password/forgot-password.module";
import {RouterModule} from "@angular/router";


@NgModule({
  declarations: [LoginComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        MatCardModule,
        MatSelectModule,
        MatListModule,
        MatAutocompleteModule,
        AccountRequestModule,
        ForgotPasswordModule,
        RouterModule
    ]
})
export class LoginModule { }
